export function representativeEntityId(input: { unitId: string; entityId: string; type: 'target' | 'source' }) {
	const { entityId, type, unitId } = input;
	return `${unitId}___${entityId}___${type}`;
}
